(function() {
  // Skip on touch devices — no cursor needed
  if ('ontouchstart' in window) return;

  // Signal to CSS that custom cursor is active (gates cursor: none rules)
  document.body.classList.add('has-custom-cursor');

  var dot = document.getElementById('cursor-dot');
  var ring = document.getElementById('cursor-ring');
  var text = document.getElementById('cursor-text');

  if (!dot || !ring || !text) return;

  var mouseX = 0, mouseY = 0;
  var ringX = 0, ringY = 0;

  // Dot follows cursor instantly
  document.addEventListener('mousemove', function(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (typeof gsap === 'undefined') return;
    // Center the 6px dot on the cursor
    gsap.set(dot, { x: mouseX - 3, y: mouseY - 3 });
    // Center the cursor text near cursor
    gsap.set(text, { x: mouseX + 16, y: mouseY - 8 });
  });

  // Ring follows with lerp (smooth lag)
  if (typeof gsap !== 'undefined') {
    gsap.ticker.add(function() {
      ringX += (mouseX - ringX - 20) * 0.12;
      ringY += (mouseY - ringY - 20) * 0.12;
      gsap.set(ring, { x: ringX, y: ringY });
    });
  }

  // Hover state: links and buttons — ring scales up
  document.querySelectorAll('a, button, [data-magnetic]').forEach(function(el) {
    el.addEventListener('mouseenter', function() {
      if (typeof gsap === 'undefined') return;
      gsap.to(ring, { scale: 2.5, background: 'rgba(201,168,76,0.15)', duration: 0.3, ease: 'power2.out' });
      gsap.to(dot, { opacity: 0, duration: 0.3 });
    });
    el.addEventListener('mouseleave', function() {
      if (typeof gsap === 'undefined') return;
      gsap.to(ring, { scale: 1, background: 'transparent', duration: 0.3, ease: 'power2.out' });
      gsap.to(dot, { opacity: 1, duration: 0.3 });
    });
  });

  // Hover state: product cards — larger ring + show "VOIR" text
  document.querySelectorAll('.product-card').forEach(function(el) {
    el.addEventListener('mouseenter', function() {
      if (typeof gsap === 'undefined') return;
      gsap.to(ring, { scale: 3, duration: 0.3, ease: 'power2.out' });
      text.textContent = 'VOIR';
      gsap.to(text, { opacity: 1, duration: 0.3 });
    });
    el.addEventListener('mouseleave', function() {
      if (typeof gsap === 'undefined') return;
      gsap.to(ring, { scale: 1, duration: 0.3, ease: 'power2.out' });
      gsap.to(text, { opacity: 0, duration: 0.3 });
    });
  });

  // Click burst effect
  document.addEventListener('click', function() {
    if (typeof gsap === 'undefined') return;
    gsap.to(ring, {
      scale: 0.8, duration: 0.1, ease: 'power2.in',
      onComplete: function() {
        gsap.to(ring, { scale: 1, duration: 0.2, ease: 'power2.out' });
      }
    });
    gsap.to(dot, {
      scale: 2, duration: 0.1, ease: 'power2.in',
      onComplete: function() {
        gsap.to(dot, { scale: 1, duration: 0.2, ease: 'power2.out' });
      }
    });
  });

  // Hide cursor when leaving window
  document.addEventListener('mouseleave', function() {
    if (typeof gsap === 'undefined') return;
    gsap.to([dot, ring, text], { opacity: 0, duration: 0.3 });
  });
  document.addEventListener('mouseenter', function() {
    if (typeof gsap === 'undefined') return;
    gsap.to([dot, ring, text], { opacity: 1, duration: 0.3 });
  });
})();
